import { createSlice } from '@reduxjs/toolkit'

export const statesSlice = createSlice({
  name: 'states',
  initialState: [],
  reducers: {
    updateStates: (state, action) => {
      return action.payload;
    },
  },
})

export const { updateStates } = statesSlice.actions

export default statesSlice.reducer
